import styled from '@emotion/styled'
import { Box, TableContainer, TableHead } from '@mui/material'
import { exportToPPT_tableCss, tableCss } from '../../../../util'
import { MEDIA } from '../../../../constants'

export const RootWrap = styled(Box)(
  (props) => `
    & table thead {
      position: sticky;
      top: 0;
      background: #fff;
      z-index: 5;
      border-bottom: 1px #DFE2F2 solid;
      // box-shadow: 0px 5px 10px rgba(0,0,0,0.05);
    }

    & .th-border {
      box-shadow: 0px 5px 10px rgba(0,0,0,0.05);
    }

    & .tableWrapper hr{
      display : none;
    }

    &.stickyCustomTable .tableWrapper th, &.stickyCustomTable .tableWrapper td {
      width: calc(100% - ${props.showAdminButtons ? '110' : '0'}px / ${props.table_cols});
      border : none; 
      border-bottom : 1px solid #D8D8D6;

      ul {
        margin-left : 18px;
      }
    }

    &.stickyCustomTable .tableWrapper th {
      border-top : 1px solid #D8D8D6;
      vertical-align: baseline;

      svg {
        position : relative;
        top : 2px;
      }
    }

    &  table.MuiTable-root  {
      border-left: 1px solid #DFE2F2;
      border-right: 1px solid #DFE2F2;
    }

	&.exportToPPT {padding:0; width:1200px;}
	&.exportToPPT .progressionWrapper {display:none;}
    &.exportToPPT {
        * {font-size: 14px;}
    }
    ${exportToPPT_tableCss}
    
	@media (max-width: ${MEDIA.lg}) {
		padding:20px 20px 40px 20px;
	}
`
)

export const TableContainerWrapper = styled(TableContainer)(`
    border-collapse: collapse;
    background-color: #FFF;
    & table { table-layout: fixed; }
    // & table .colHeading { width:200px; }
    & table .colAction { width:110px !important; }
    & td, & th {
        // border: 1px solid #DFE2F2;
        text-align: left;
        vertical-align: top;
        overflow-wrap: anywhere;
        padding-left: 8px;
        padding-right: 8px;
    }
    & tr th {
        // background-color: #F7F8FD;
        text-transform: none !important;
        font-size: 14px !important;
    }
    // & tr:nth-of-type(even) {
    //     background: #F6F7FCCC !important;
    // }
    & tr th {
        cursor:pointer;
    }
    ${tableCss}
    overflow: unset;
`)

export const ProgressionWrapper = styled(Box)(`
    padding: 8px;
    margin-bottom: 10px;
    border-radius: 4px;
    position:relative;
    display:flex;
    justify-content: space-between;
    background: #F6F6F5;

    & .filterOuterWrap {width:auto;}
    & .searchBox { width: 100%; margin-top:2px; }
    & .searchBox input {
        padding: 0 26px 0 14px;
        line-height: 30px;
        height: 30px;
    }
    & .themeV2 .searchBox input {padding : 0 4px;}
    & .multiSelectWrap  {
        top : 2px;

      .MuiSelect-select {
         max-width: 50vw;
      }
    }
    & .input-wrapper-new {
      width : 51%;
    }

    & .clearSearchBox {
        position: relative;
        z-index: 1;
        margin-left: -26px;
    }
`)
